import Gallerie from "@/front/components/post-type/magasin/Gallerie";

new Vue({
  el: '.magasin__photos',
  render: h => h(Gallerie)
});
